import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();
  const [message, setMessage] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
		setMessage("Sending...");

    emailjs
      .sendForm(
        process.env.YOUR_SERVICE_ID,   // service ID from EMAILJS 
        process.env.YOUR_TEMPLATE_ID,  // EmailJS template ID
        form.current,
        process.env.YOUR_PUBLIC_KEY   // EmailJS public key

        // I didnt put those values because I created an account with EMAILJS and I am still awaiting approval, if you want to see here are the credentials to EMAILJS account charlottem@tendaiict.com password:charlotte.pebbbles 
      )
      .then(
        (result) => {
          setMessage("Message sent successfully!");
          e.target.reset();
        },
        (error) => {
          setMessage("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{ backgroundImage: "url('assets/img/bg/breadcumb-bg.jpg')" }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
            <ul className="breadcumb-menu">
              <li><a href="/">Home</a></li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="space-top">
        <div className="space-bottom overflow-hidden">
          <div className="container">
            <div className="row gy-5">
              <div className="col-lg-6">
                <div className="">
                  <div className="title-area mb-30">
                    <span className="sub-title style1">Get In Touch</span>
                    <h6 className="sec-title">For all enquiries please feel free to give us your details below and we will gladly contact you back as soon as we can. Please note all fields are compulsory below.</h6>
                  </div>
                  <form
                    ref={form}
                    onSubmit={sendEmail}
                    className="contact-form2 style"
                  >
                    <div className="row">
                      <div className="form-group col-md-6">
                        <input type="text" className="form-control" name="name" id="name" placeholder="Your Name" />
                        <i className="fal fa-user"></i>
                      </div>
                      <div className="form-group col-md-6">
                        <input type="email" className="form-control" name="email" id="email" placeholder="Email Address" />
                        <i className="fal fa-envelope"></i>
                      </div>
                      <div className="form-group col-md-6">
                        <input type="tel" className="form-control" name="number" id="number" placeholder="Phone Number" />
                        <i className="fal fa-phone"></i>
                      </div>
                      <div className="form-group col-md-6">
                        <input type="text" className="form-control" id="subject" name="subject" placeholder="Your subject" />
                        <i className="fal fa-envelope"></i>
                      </div>
                      <div className="form-group col-12">
                        <textarea
                          name="message"
                          id="message"
                          cols="30"
                          rows="3"
                          className="form-control"
                          placeholder="Your Message"
                        ></textarea>
                        <i className="fal fa-pencil"></i>
                      </div>
                      <div className="form-btn col-12">
                        <button className="th-btn th-radius2">
                          Send Message
                          <i className="fa-regular fa-arrow-right ms-2"></i>
                        </button>
                      </div>
                    </div>
                    <p className="form-messages mb-0 mt-3"></p>
                  </form>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.894634719632!2d28.01349141501917!3d-26.017309983463034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e956b6bbdb0c94f%3A0xabcdef1234567890!2s61%20Bosbok%20Rd%2C%20Randparkridge%2C%20Randburg%2C%20Gauteng%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1693245600000!5m2!1sen!2sza"
                    width="100%"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Tendai ICT Location"
                  ></iframe>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
